import React, { useState, useRef, useEffect, useCallback } from 'react';
import Filter_RangeAnalysis from "./Filter_RangeAnalysis/Filter_RangeAnalysis";
import SingleChargePerformance from './SingleChargePerformance';
import TopVehicles from './TopVehicles';
import FleetVehiclePerformance from './FleetVehiclePerformance';
import styles from './RangeAnalysisTab_ace.module.css';

const RangeAnalysisTab = () => {

  return (
    <>
      <div className={`container-fluid ${styles.container}`}>
        <Filter_RangeAnalysis />
        <SingleChargePerformance />
        <TopVehicles />
        <FleetVehiclePerformance />
      </div>
    </>
  );
};

export default RangeAnalysisTab;
